import { RSSign } from "../utils/sign.js";
import SyModel from "../models/sy.js";
// import Ciphertext from "../utils/Ciphertext";
import Storage from "../utils/storage.js";

const Report = {
    /*
       *@functionName: webDotFather
       *@params1: 渠道id = cch_id
       *@params2: 游戏id = app_id
       *@params3: 广告系列id = ukey
       *@params4: 埋点 = node
       *@params5: sdk版本 = sdk_ver
       *@params6: 应用版本名称 = app_ver
       *@params7: 应用版本号 = app_version_code
       *@description: 埋点数据上报
       *@author: 赖雪婷
       *@date: 2022-04-18 17:16:44
   */
    webDotFather(pid, appid, ukey, node) {
        window._hmt.push(["_trackEvent", "click", node]);
        let data = {
            tm: new Date().getTime(),
            cch_id: pid,
            app_id: appid,
            ukey: ukey,
            node: node,
            sdk_ver: "1.0",
            app_ver: "枫之谷",
            app_version_code: "1.0",
        };
        data.device_id = Storage.localStorageGet("deviceIdUa");
        data.sign = RSSign(data, data.app_id);
        SyModel.webDot(data).then(res => {
            if (res.code == 200) {
                console.log(res.msg);
            }
        }).catch(err => {
            console.log(err);
        });
    },
    /*
    *@functionName: webErrorlogFather
    *@params1: 渠道id = cch_id
    *@params2: 游戏id = app_id
    *@params3: 广告系列id = ukey
    *@params4: 错误信息 = error_msg
    *@params4: 执行动作 = action
    *@params5: sdk版本 = sdk_ver
    *@params6: 应用版本名称 = app_ver
    *@params7: 应用版本号 = app_version_code
    *@description: 错误日志上报
    *@author: 赖雪婷
    *@date: 2022-04-18 17:16:44
    */
    webErrorlogFather(pid, appid, ukey, error_msg, action) {
        let data = {
            tm: new Date().getTime(),
            cch_id: pid,
            app_id: appid,
            ukey: ukey,
            error_msg: error_msg,
            action: action,
            sdk_ver: "1.0",
            app_ver: "枫之谷",
            app_version_code: "1.0",
        };
        data.device_id = Storage.localStorageGet("deviceIdUa");
        data.sign = RSSign(data, data.app_id);
        SyModel.webErrorlog(data).then(res => {
            if (res.code == 200) {
                console.log(res.msg);
            }
        });
    },
    /*
    *@functionName: webErrorlogFather
    *@params1: 渠道id = cch_id
    *@params2: 游戏id = app_id
    *@params3: 广告系列id = ukey
    *@params4: sdk版本 = sdk_ver
    *@params5: 应用版本名称 = app_ver
    *@params6: 应用版本号 = app_version_code
    *@description: 设备信息上报
    *@author: 赖雪婷
    *@date: 2022-04-18 17:16:44
    */
    webDevice(pid, appid, ukey) {
        let data = {
            tm: new Date().getTime(),
            cch_id: pid,
            app_id: appid,
            ukey: ukey,
            sdk_ver: "1.0",
            app_ver: "枫之谷",
            app_version_code: "1.0",
        };
        data.device_id = Storage.localStorageGet("deviceIdUa");
        data.sign = RSSign(data, data.app_id);
        SyModel.webDevice(data).then(res => {
            if (res.code == 200) {
                console.log("收集设备信息接口200返回：", res.msg);
            }
        });
    },
}
export default Report;